import React from "react";
import { Table } from "reactstrap";

const PrintableTable = ({ creditItems }) => {
  const totalAmount = creditItems.reduce((sum, row) => sum + row.amount, 0);
  const totalPaidAmount = creditItems.reduce((sum, row) => sum + row.paidAmount, 0);
  const totalRemainingAmount = creditItems.reduce((sum, row) => sum + row.remainingAmount, 0);

  return (
    <Table bordered className="table-nowrap">
      <thead>
        <tr>
          <th style={{ width: "80px" }}>S.N</th>
          <th>Customer Name</th>
          <th className="text-end">Total Amount</th>
          <th className="text-end">Paid Amount</th>
          <th className="text-end">Remaining Amount</th>
        </tr>
      </thead>
      <tbody>
        {creditItems.map((item, index) => (
          <tr key={item.id || index}>
            <td>{index + 1}</td>
            <td>{item.customerName}</td>
            <td className="text-end">{item.amount.toFixed(2)}</td>
            <td className="text-end">{item.paidAmount.toFixed(2)}</td>
            <td className="text-end">{item.remainingAmount.toFixed(2)}</td>
          </tr>
        ))}
        {creditItems.length > 0 && (
          <tr className="fw-bold">
            <td></td>
            <td>Total</td>
            <td className="text-end">{totalAmount.toFixed(2)}</td>
            <td className="text-end">{totalPaidAmount.toFixed(2)}</td>
            <td className="text-end">{totalRemainingAmount.toFixed(2)}</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default PrintableTable;